export const toCamelCaseKey = (rawValue: string): string => {
  const value = (rawValue || "")
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/[^a-zA-Z0-9\s_-]/g, " ")
    .replace(/[_-]+/g, " ");

  const parts = value
    .split(/\s+/)
    .map((part) => part.trim())
    .filter((part) => !!part);

  if (!parts.length) {
    return "";
  }

  return parts
    .map((part, index) => {
      const normalized = part.toLowerCase();
      if (index === 0) {
        return normalized;
      }
      return normalized.charAt(0).toUpperCase() + normalized.slice(1);
    })
    .join("");
};
